import { Injectable } from '@angular/core';
import {AppConfiguration} from './app-configuration';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JsonAppConfigService extends AppConfiguration {

  constructor(private http: HttpClient) { 
    super();
  }

  load(){
    return this.http.get<AppConfiguration>('/assets/data/appConfig.json')
    .toPromise()
    .then(data => {
      this.urlInformation = data['urlInformation'];
      this.urlClientInformation = data['apiBaseUrl'];
      this.userName = data['userName'];
      this.pass = data['pass'];
      this.fleetuserid = data['fleetuserid'];
      this.conncode = data['conncode'];   
      this. polarixapiuser = data['polarixapiuser'];
      this.polarixapipass = data['polarixapipass'];
    })
    .catch(() => {
     console.error("Could not load Service Map configuration");
    });
  }

}

// this.urlInformation = "https://wsapi.foresightgps.com/ForesightFlexAPI.ashx";
//       this.urlClientInformation = "http://cube-mia.com/apicubeedge/";
//       this.userName = "qa@sfc-mia.com";
//       this.pass = "123456";
//       this.fleetuserid = "487";
//       this.conncode = "PolarixUSA";
//       this. polarixapiuser = "terpel";
//       this.polarixapipass = "fsgpsTerpel";
